import(/* webpackMode: "eager" */ "/app/src/app/(default)/layout.tsx")